const CloseIcon = ({ className = '', size = 56, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block ${className}`}
      {...props}
    >
      <path
        d="M45.554 8.54543L29.8194 4.46641C23.6671 2.8715 18.3431 6.08149 16.579 12.4515L12.5069 27.1548C10.7476 33.5068 13.6999 38.8604 19.8522 40.4553L35.5868 44.5343C41.739 46.1292 47.0443 42.9163 48.8035 36.5643L52.8756 21.861C54.6398 15.491 51.7062 10.1403 45.554 8.54543Z"
        fill="url(#paint0_linear_749_69584)"
      />
      <g filter="url(#filter0_f_749_69584)">
        <path
          d="M39.6396 13.6184L28.1993 10.6526C23.7262 9.49298 19.8553 11.8269 18.5726 16.4584L15.6118 27.1488C14.3328 31.7672 16.4792 35.6596 20.9524 36.8192L32.3927 39.785C36.8659 40.9446 40.7232 38.6086 42.0023 33.9902L44.963 23.2998C46.2457 18.6683 44.1128 14.778 39.6396 13.6184Z"
          fill="#CA2C26"
        />
      </g>
      <foreignObject x="-12.6" y="-1.40078" width="70.8204" height="70.0042">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{ backdropFilter: 'blur(6.55px)', clipPath: 'url(#bgblur_0_749_69584_clip_path)', height: '100%', width: '100%' }}
        ></div>
      </foreignObject>
      <g data-figma-bg-blur-radius="13.1">
        <mask
          id="path-3-outside-1_749_69584"
          maskUnits="userSpaceOnUse"
          x="0"
          y="11.1992"
          width="46"
          height="45"
          fill="black"
        >
          <rect fill="white" y="11.1992" width="46" height="45" />
          <path d="M32.2757 12.1992H13.3663C5.97271 12.1992 1 17.2929 1 24.8693V42.3569C1 49.9119 5.97271 55.0034 13.3663 55.0034H32.2757C39.6693 55.0034 44.6202 49.9119 44.6202 42.3569V24.8693C44.6202 17.2929 39.6693 12.1992 32.2757 12.1992Z" />
        </mask>
        <path
          d="M32.2757 12.1992H13.3663C5.97271 12.1992 1 17.2929 1 24.8693V42.3569C1 49.9119 5.97271 55.0034 13.3663 55.0034H32.2757C39.6693 55.0034 44.6202 49.9119 44.6202 42.3569V24.8693C44.6202 17.2929 39.6693 12.1992 32.2757 12.1992Z"
          fill="#CA2C26"
          fillOpacity="0.06"
        />
        <path
          d="M32.2757 11.6992C31.9996 11.6992 31.7757 11.9231 31.7757 12.1992C31.7757 12.4754 31.9996 12.6992 32.2757 12.6992V11.6992ZM32.2757 12.1992V11.6992H13.3663V12.1992V12.6992H32.2757V12.1992ZM13.3663 12.1992V11.6992C9.5511 11.6992 6.32502 13.0159 4.05275 15.3439C1.7815 17.6707 0.5 20.97 0.5 24.8693H1H1.5C1.5 21.1922 2.70485 18.1564 4.76836 16.0424C6.83085 13.9294 9.78794 12.6992 13.3663 12.6992V12.1992ZM1 24.8693H0.5V42.3569H1H1.5V24.8693H1ZM1 42.3569H0.5C0.5 46.2459 1.78174 49.5392 4.05301 51.8628C6.32524 54.1873 9.55119 55.5034 13.3663 55.5034V55.0034V54.5034C9.78786 54.5034 6.83064 53.2738 4.76811 51.1638C2.70461 49.0528 1.5 46.0229 1.5 42.3569H1ZM13.3663 55.0034V55.5034H32.2757V55.0034V54.5034H13.3663V55.0034ZM32.2757 55.0034V55.5034C36.091 55.5034 39.3117 54.1872 41.5786 51.8623C43.8444 49.5386 45.1202 46.2452 45.1202 42.3569H44.6202H44.1202C44.1202 46.0235 42.9207 49.0535 40.8626 51.1642C38.8056 53.2738 35.8541 54.5034 32.2757 54.5034V55.0034ZM44.6202 42.3569H45.1202V24.8693H44.6202H44.1202V42.3569H44.6202ZM44.6202 24.8693H45.1202C45.1202 20.9706 43.8446 17.6714 41.5788 15.3443C39.3119 13.016 36.091 11.6992 32.2757 11.6992V12.1992V12.6992C35.854 12.6992 38.8054 13.9293 40.8624 16.0419C42.9204 18.1557 44.1202 21.1916 44.1202 24.8693H44.6202Z"
          fill="url(#paint1_linear_749_69584)"
          mask="url(#path-3-outside-1_749_69584)"
        />
      </g>
      <foreignObject x="7.07974" y="17.984" width="31.4365" height="31.1818">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{ backdropFilter: 'blur(4.29px)', clipPath: 'url(#bgblur_1_749_69584_clip_path)', height: '100%', width: '100%' }}
        ></div>
      </foreignObject>
      <g filter="url(#filter2_d_749_69584)" data-figma-bg-blur-radius="8.58627">
        <path
          d="M29.3737 37.3907C30.1152 38.1184 30.1152 39.2955 29.3737 40.021C29.0029 40.3848 28.5231 40.5796 28.0214 40.5796C27.5416 40.5796 27.0618 40.4084 26.691 40.021L22.8088 36.235L18.9266 40.021C18.5559 40.3848 18.076 40.5796 17.5744 40.5796C17.0946 40.5796 16.5929 40.3848 16.2222 40.021C15.4806 39.2955 15.4806 38.1184 16.2222 37.3693L20.1044 33.5811L16.2222 29.7694C15.4806 29.0439 15.4806 27.8453 16.2222 27.1177C16.9637 26.3879 18.1633 26.3879 18.9266 27.1177L22.8088 30.9251L26.6692 27.1177C27.4326 26.3879 28.6321 26.3879 29.3737 27.1177C30.1152 27.8453 30.1152 29.0439 29.3737 29.7694L25.4915 33.5811L29.3737 37.3907Z"
          fill="url(#paint2_linear_749_69584)"
        />
        <path
          d="M26.749 27.1982C27.4688 26.5116 28.5971 26.5146 29.293 27.1992H29.2939C29.9896 27.882 29.9893 29.007 29.2939 29.6875L25.4111 33.499L25.3281 33.5811L25.4111 33.6631L29.2939 37.4727C29.9895 38.1555 29.9894 39.259 29.2939 39.9395C28.9443 40.2825 28.4928 40.4648 28.0215 40.4648C27.5694 40.4648 27.1203 40.3038 26.7734 39.9414L26.7705 39.9395L22.8887 36.1533L22.8086 36.0752L22.7285 36.1533L18.8467 39.9395C18.4971 40.2825 18.0455 40.4648 17.5742 40.4648C17.1242 40.4648 16.6518 40.2818 16.3027 39.9395H16.3018C15.607 39.2596 15.6048 38.1544 16.3027 37.4492L20.1846 33.6631L20.2676 33.5811L20.1846 33.499L16.3027 29.6875H16.3018C15.6064 29.0069 15.6069 27.882 16.3027 27.1992C16.9555 26.5569 17.9884 26.515 18.708 27.0791L18.8477 27.2002L22.7285 31.0068L22.8086 31.0859L22.8896 31.0068L26.749 27.1982Z"
          stroke="url(#paint3_linear_749_69584)"
          strokeWidth="0.228967"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_749_69584"
          x="5.51498"
          y="0.627044"
          width="49.5479"
          height="49.1834"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.86556" result="effect1_foregroundBlur_749_69584" />
        </filter>
        <clipPath id="bgblur_0_749_69584_clip_path" transform="translate(12.6 1.40078)">
          <path d="M32.2757 12.1992H13.3663C5.97271 12.1992 1 17.2929 1 24.8693V42.3569C1 49.9119 5.97271 55.0034 13.3663 55.0034H32.2757C39.6693 55.0034 44.6202 49.9119 44.6202 42.3569V24.8693C44.6202 17.2929 39.6693 12.1992 32.2757 12.1992Z" />
        </clipPath>
        <filter
          id="filter2_d_749_69584"
          x="7.07974"
          y="17.984"
          width="31.4365"
          height="31.1818"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.86209" dy="2.86209" />
          <feGaussianBlur stdDeviation="2.86209" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.321569 0 0 0 0 0.54902 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_749_69584" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_749_69584" result="shape" />
        </filter>
        <clipPath id="bgblur_1_749_69584_clip_path" transform="translate(-7.07974 -17.984)">
          <path
            d="M29.3737 37.3907C30.1152 38.1184 30.1152 39.2955 29.3737 40.021C29.0029 40.3848 28.5231 40.5796 28.0214 40.5796C27.5416 40.5796 27.0618 40.4084 26.691 40.021L22.8088 36.235L18.9266 40.021C18.5559 40.3848 18.076 40.5796 17.5744 40.5796C17.0946 40.5796 16.5929 40.3848 16.2222 40.021C15.4806 39.2955 15.4806 38.1184 16.2222 37.3693L20.1044 33.5811L16.2222 29.7694C15.4806 29.0439 15.4806 27.8453 16.2222 27.1177C16.9637 26.3879 18.1633 26.3879 18.9266 27.1177L22.8088 30.9251L26.6692 27.1177C27.4326 26.3879 28.6321 26.3879 29.3737 27.1177C30.1152 27.8453 30.1152 29.0439 29.3737 29.7694L25.4915 33.5811L29.3737 37.3907Z"
          />
        </clipPath>
        <linearGradient id="paint0_linear_749_69584" x1="34.7017" y1="27.6061" x2="-1.47732" y2="34.4854" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF2820" />
          <stop offset="1" stopColor="#CA2C26" />
        </linearGradient>
        <linearGradient id="paint1_linear_749_69584" x1="7.94363" y1="17.186" x2="40.9362" y2="53.3915" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint2_linear_749_69584" x1="28.9185" y1="29.1001" x2="13.0306" y2="29.6275" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient id="paint3_linear_749_69584" x1="17.9366" y1="28.2024" x2="26.8378" y2="39.4271" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CloseIcon;